<template>
  <div class="section">
    <div class="container auth-container">
      <h2 class="title mb-1 is-4 has-text-weight-semibold">{{ $t('auth.createAccount') }}</h2>
      <p>{{ $t(`auth.createAccountAndNeverMissAnEvent`, { msg: $store.state.appName}) }}</p>

      <!-- SIGNUP PREFERENCES -->
      <div v-show="!isEmailPrefered">
       
        <div class="field mt-1-half">
          <div class="control">
            <button
              class="button is-outlined is-default-size is-fullwidth"
              :disabled="isLoading"
              @click="googleSignIn"
            >
              <span class="icon">
                <i class="mdi mdi-google mdi-16px"></i>
              </span>
              <span style="padding-left: 4px">{{$t('auth.signUpWithGoogle')}}</span>
            </button>
          </div>
        </div>
         <!-- FACEBOOK SIGNIN BUTTON -->
        <div class="field mt-1">
          <div class="control">
            <button
            disabled
              class="button is-outline is-default-size  is-fullwidth has-icons-left"
              @click="facebookSignIn" :class="{ 'is-loading': isLoading }"
            >
              <span class="icon is-left">
                <i class="mdi mdi-facebook mdi-16px"></i>
              </span>
              <span>{{$t('auth.signUpWithFacebook')}}</span>
            </button>
          </div>
        </div>
        <!-- ./FACEBOOK SIGNIN BUTTON -->


        <div class="field mt-1">
          <div class="control">
            <button
              class="button is-outlined is-default-size is-fullwidth"
              :class="{ 'is-loading': isLoading }"
              @click="isEmailPrefered = true"
            >
              <span class="icon">
                <i class="mdi mdi-email-outline mdi-16px"></i>
              </span>
              <span class="pl-half">{{$t('auth.signUpWithEmail')}}</span>
            </button>
          </div>
        </div>
      </div>
      <!-- ./SIGNUP PREFERENCES -->

      <div v-show="isEmailPrefered" class="mt-1">
        <p class="is-size-6-half has-text-centered has-text-weight-semibold">
          <!-- <a class="has-text-link" href>Facebook</a>&nbsp;yada -->
          <a href class="has-text-cyan" @click.prevent="googleSignIn">Google</a>&nbsp;yada
          <a href class="has-text-cyan" @click.prevent="facebookSignIn">Facebook</a>
          ile hesap aç
        </p>
        <hr class="hr-text" :data-content="$t('ui.or')" />
      </div>

      <!-- ERROR MESSAGE -->
      <article class="message is-danger mt-1" v-if="isErr">
        <div class="message-body">{{ errMsg }}</div>
      </article>
      <!-- ./ERROR MESSAGE -->

      <!-- SIGN UP FORM -->
      <form @submit.prevent="signUp" class="auth-form mt-1" v-if="isEmailPrefered">
        <!-- email -->
        <div class="field">
          <!-- <label class="label" for="email">{{$t('auth.email')}}</label> -->
          <div class="control has-icons-right">
            <input
              class="input "
              name="email"
              :class="{ 'is-danger': isEmailErr }"
              type="email"
              :placeholder="$t('auth.enterYourEmail')"
              v-model="account.email"
              @input="resetErrs"
              @focus="hideBottomNavbar(true)"
              @blur="hideBottomNavbar(false)"
              autocomplete="on"
              required
            />
            <span class="icon is-small is-right">
              <i class="mdi mdi-email-outline mdi-16px"></i>
              <!-- <img src="@/assets/svg/outline-email.svg" alt="email icon"> -->
            </span>
          </div>
          <p class="help" v-show="isEmailErr">{{emailErrMsg}}</p>
        </div>
        <!-- ./email -->

        <!-- USERNAME -->
        <div class="field">
          <!-- <label class="label">{{$t('auth.username')}}</label> -->
          <div class="control has-icons-right">
            <input
              class="input"
              type="text"
              :placeholder="$t('auth.enterYourUsername')"
              minlength="4"
              maxlength="16"
              ref="username"
              @input="isValidUname"
              @focus="hideBottomNavbar(true)"
              @blur="hideBottomNavbar(false)"
              autocomplete="off"
              required
            />
            <span class="icon is-small is-right">
              <i class="mdi mdi-account-outline mdi-16px"></i>
            </span>
            <!-- todo: @input doesnt work on mobile -->
            <p class="help is-success is-size-7" :class="{ 'is-danger': isWarn }">{{warnMsg}}</p>
          </div>
          <!-- <p class="help is-danger" v-show="isNameErr">{{nameErrMsg}}</p> -->
        </div>
        <!-- ./USERNAME -->

        <!-- password -->
        <div class="field">
          <!-- <label class="label">{{$t('auth.password')}}</label> -->
          <div class="control has-icons-right">
            <input
              class="input"
              :class="{ 'is-danger': isPwErr }"
              :type="showPassword ? 'text' : 'password'"
              name="password"
              minlength="6"
              maxlength="24"
              :placeholder="$t('auth.enterYourPassword')"
              @input="resetErrs"
              @focus="hideBottomNavbar(true)"
              @blur="hideBottomNavbar(false)"
              v-model="account.password"
              autocomplete="on"
              required
            />
            <span class="icon is-small is-right">
              <i class="mdi mdi-lock-outline mdi-16px"></i>
            </span>
            <p
              class="has-text-right is-size-14px has-text-link mt-half cursor-pointer"
              @click="showPassword = !showPassword"
            >{{ showPassword ? $t('auth.hidePassword') : $t('auth.showPassword') }}</p>
          </div>
        </div>
        <!-- ./password -->

        <div class="field">
          <p class="is-size-7">
            Bu formu onaylayarak {{ $store.state.appName }}'nın
            <router-link :to="{name: 'help'}">Kullanıcı Sözleşmesini</router-link>&nbsp;kabul etmiş olursunuz.
          </p>
        </div>

        <div class="field">
          <div class="control">
            <button
              class="button is-primary is-default-size is-fullwidth"
              :class="{ 'is-loading': isLoading }"
              :disabled="isDisabled"
            >{{ $t('auth.createYourAccount', { msg: $store.state.appName }) }}</button>
          </div>
        </div>
      </form>
      <!-- ./SIGN UP FORM -->
    </div>

    <p class="has-text-centered mt-2">
      {{$t('auth.doYouHaveAccount')}}
      <router-link :to="{ name: 'signin' }">{{$t('auth.logIn')}}</router-link>
    </p>
  </div>
</template>

<script>
import { auth, db, fbFunctions } from "@/fireinit";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      account: {
        email: "",
        password: "",
        username: ""
        // pw1: ""
      },
      showPassword: false,
      usernames: [],
      isErr: false,
      errMsg: "",
      isEmailPrefered: false,
      isLoading: false,
      isPwErr: false,
      pwErrMsg: "",
      isEmailErr: false,
      emailErrMsg: "",
      isWarn: false,
      warnMsg: "",
      isDisabled: false,
      minLen: 4,
      maxLen: 12
    };
  },
  mounted() {
    this.getUsernames();
  },
  methods: {
    ...mapMutations({
      hideBottomNavbar: "ui/SET_HIDE_BOTTOM_NAVBAR"
    }),
    googleSignIn() {
      this.$store.dispatch("auth/googleSignIn");
    },
    facebookSignIn() {

    },
    async getUsernames() {
      try {
        const qSnap = await db.collection("users").get();
        qSnap.forEach(doc => {
          this.usernames.push(doc.data().username);
        });
      } catch (error) {
        console.log(error);
      }
    },
    isValidUname(e) {
      this.isDisabled = false;

      // force toconvert to lowercase
      this.$refs.username.value = this.account.username = e.target.value.toLocaleLowerCase();

      if (this.account.username.length < 4) {
        this.warnMsg = "";
        return;
      }

      if (!/^[a-z]+$/.test(this.account.username)) {
        this.isWarn = true;
        this.isDisabled = true;
        this.warnMsg = `Yalnızca harf kullanabilirsin.`;
      } else if (this.usernames.indexOf(this.account.username.trim()) > -1) {
        this.isWarn = true;
        this.isDisabled = true;
        this.warnMsg = `@${this.account.username} başkası tarafından alınmış`;
      } else {
        this.isWarn = false;
        this.isDisabled = false;
        this.warnMsg = `@${this.account.username} kullanılabilir`;
      }
    },
    resetErrs() {
      this.isErr = false;
      this.errMsg = "";
      this.isPwErr = false;
      this.isEmailErr = false;
    },
    async signUp() {
      // const user = { email: this.account.email, username: this.account.username, password: this.account.pw }
      this.resetErrs();
      this.isLoading = true;

      try {
        const createNewUser = fbFunctions.httpsCallable(
          "createNewUserWithEmailAndPassword"
        );
        await createNewUser(this.account);

        // console.log('written succcess', r.data)

        await this.$store.dispatch("auth/signIn", this.account);
        // this.$store.dispatch('auth/setUser', r.data)

        // TODO move sending mail verification to backend
        this.$store.dispatch("auth/sendEmailVerification");

        this.$router.push({ name: "home" });
      } catch (error) {
        if (error.message === "auth/email-already-exists") {
          this.isErr = true;
          this.isEmailErr = true;
          this.errMsg = `Girmiş olduğunuz e-posta adresi (${this.account.email}) kullanımda. Lütfen, farklı bir e-posta adresi ile hesap oluşturmayı deneyin.`;
          this.account.password = "";
        } else if (error.message === "user/invalid-username") {
          this.isErr = true;
          this.errMsg =
            error.details || "Kullanıcı ismi hatalı. Lütfen tekrar deneyin.";
        } else {
          this.isErr = true;
          this.errMsg =
            "Bizden kaynaklı bir hata oluştu. Lütfen tekrar hesap oluşturmayı deneyin.";
        }
      }
      this.resetErrs();
      this.isLoading = false;
      return;
    }
  },

  beforeRouteEnter(to, from, next) {
    if (auth.currentUser && !auth.currentUser.isAnonymous) {
      next({ name: "user-profile", params: { userId: auth.currentUser.uid } });
    } else {
      next();
    }
  }
};
</script>